import React, { FC } from 'react';
import styles from './Counter.module.scss';
import Increment from '@/components/icons/Increment';
import Decrement from '@/components/icons/Decrement';

interface CounterProps {
  title: string;
  count: number;
  disableIncrement: boolean;
  disableDecrement: boolean;
  onIncrease: ()=> void;
  onDecrease: ()=> void;
}

const Counter: FC<CounterProps> = ({title, count, disableDecrement,disableIncrement, onIncrease, onDecrease}) => {
  return (
    <div className={styles.counterContainer} data-testid='Counter'>
      <p className={styles.title}>{title}</p>
      <div className={styles.counterRow}>
        <button className={`${styles.quantityButton} ${disableDecrement? styles.disabled : ""}`} onClick={(event)=>{
          event.preventDefault();
          event.stopPropagation();
          onDecrease();
        }} disabled={disableDecrement}><Decrement/></button>
        <p className={styles.count}>{count}</p>
        <button className={`${styles.quantityButton} ${disableIncrement? styles.disabled : ""}`} onClick={(event)=>{
          event.preventDefault();
          event.stopPropagation();
          onIncrease();
        }} disabled={disableIncrement}><Increment/></button>
      </div>
    </div>
  );
};



export default Counter;
